import Cookies from 'js-cookie';

export const cookieConfig = {
  essential: {
    name: 'essential',
    default: true,
    expires: 365
  },
  analytics: {
    name: 'analytics',
    default: false,
    expires: 365
  }
};

export const getCookieConsent = (type) => {
  const consent = Cookies.get(type);
  if (consent === undefined) {
    return cookieConfig[type].default;
  }
  return consent === 'true';
};

export const setCookieConsent = (type, value) => {
  Cookies.set(type, value, { expires: cookieConfig[type].expires });
};

export const clearCookieConsent = () => {
  Object.keys(cookieConfig).forEach(type => {
    Cookies.remove(type);
  });
}; 